import { useTranslation } from 'react-i18next';

import Button from '../field/Button';
import Popper from './Popper';
import * as S from './styled/ConfirmationDialog.styled';

/**
 * @author Burak Ak
 * @description This component is used to show confirmation dialog
 * @param {Object} props - props of the typography component
 * @param {Object} props.buttonRef - reference of the button
 * @param {String} props.placement - placement of the popper
 * @param {string} props.title - Title of the dialog.
 * @param {string} [props.subTitle] - Subtitle of the dialog.
 * @param {object} [props.icon] - Main icon of the dialog.
 * @param {string} [props.leftLabel] - Label of the left button.
 * @param {object} [props.leftIcon] - Icon of the left button.
 * @param {function} [props.leftAction] - Action of the left button.
 * @param {string} [props.rightLabel] - Label of the right button.
 * @param {object} [props.rightIcon] - Icon of the right button.
 * @param {function} [props.rightAction] - Action of the right button.
 * @returns {object} - Text object with the given props
 * @example
  	const [buttonRef, setButtonRef] = useState(null);
	<Button ref={setButtonRef} icon={faTrashCan} />
	<ConfirmationDialog
		buttonRef={buttonRef}
		title="filter.deleteConfirmationTitle"
		subTitle="filter.deleteConfirmationSubtitle"
		icon={faTrash}
		rightLabel="yes"
		rightIcon={faCheck}
		rightAction={() => action()}
		leftLabel="cancel"
		leftIcon={faTimes}
	/>
*
 */

const ConfirmationDialog = ({
	buttonRef,
	placement = 'bottom',
	title,
	subTitle,
	icon,
	leftLabel,
	leftIcon,
	leftAction,
	rightLabel,
	rightIcon,
	rightAction
}) => {
	const { t } = useTranslation();

	return (
		<>
			{buttonRef && (
				<Popper refElement={buttonRef} placement={placement} showArrow disableMobileView>
					{(closePopper) => (
						<S.Container>
							<S.ConfirmationDialogContainer>
								<S.TopContainer>
									{icon && <S.IconStyled icon={icon} size="large" />}
									<S.ContentCol>
										<S.Heading>{t(title)}</S.Heading>
										{subTitle && <S.Body>{t(subTitle)}</S.Body>}
									</S.ContentCol>
								</S.TopContainer>

								<S.ButtonContainer>
									<Button
										variant="outline"
										size="small"
										icon={leftIcon}
										label={leftLabel}
										onClick={() => {
											leftAction && leftAction();
											closePopper();
										}}
									/>
									<Button
										variant="blue"
										size="small"
										icon={rightIcon}
										label={rightLabel}
										onClick={() => {
											rightAction && rightAction();
											closePopper();
										}}
									/>
								</S.ButtonContainer>
							</S.ConfirmationDialogContainer>
						</S.Container>
					)}
				</Popper>
			)}
		</>
	);
};

export default ConfirmationDialog;
